<template>
  <div style="color: var(--regpwd-primarytextcolor)">
    <spinner :spinnerOn="loading"></spinner>
    <img src="" class="splash hiddden" alt="" />
    <div class="modal errorModal" role="dialog" aria-hidden="true" style="z-index: 9999">
      <div class="modal-dialog">
        <div class="modal-content" style="color: #00524a">
          <div class="modal-body">
            <div style="margin-right: 233px; width: 100%; text-align: left">
              {{ errorMsg }}
            </div>
            <a
              class="btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12"
              href="#"
              @click.prevent="errorModalClick"
              style="margin-top: 15px"
              >{{ user_lang.activationOk }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div id="userRegistration" style="display: none; box-shadow: 2px 2px 10px #ccc">
      <!--header>
  </header-->
      <div style="max-width: 800px; margin: auto; padding-top: 35px; padding: 35px; background: #fff" v-show="tokenInvalid && !enableRefIdApproach">
        <!-- <div style="padding:10px;"><div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
	<span class="exclamatory-error-icon">!</span></div>{{user_lang.tokenNotValid}}</div> -->
        <div v-if="whitelabelSpecific">
          <div style="padding: 10px">{{ user_lang.tokenNotValid }}</div>
          <div style="padding: 10px">{{ user_lang.tokenInvalidInfo }}</div>
        </div>
        <div v-if="!whitelabelSpecific">
          <div class="okta-sign-in-header auth-header">
            <img src="static/1200px-Cargill_logo.svg.png" class="auth-org-logo" alt="" />
          </div>
          <div v-if="isNetworkError" style="padding: 15px 0px">
            {{ user_lang.msgForGenericErrorUA }}
          </div>
          <div v-if="!isNetworkError">
            <div v-if="!inviteSuccess" style="padding: 10px">
              {{ user_lang.tokenInvalidShortMessage }}
            </div>
            <div v-if="!inviteSuccess && detectBrowser()" style="padding: 10px">
              {{ user_lang.browserspecificmsg }}
            </div>
            <div v-if="!inviteSuccess" style="padding: 10px">
              {{ user_lang.enterActivationDetails }}
            </div>
            <div>
              <div style="text-align: center; padding: 10px">
                <h5>{{ user_lang.resendActivation }}</h5>
              </div>
              <div v-if="!inviteSuccess">
                <div style="padding: 10px">
                  <div class="row">
                    <div class="col-12 field-reinvite">
                      <!-- <span>{{user_lang.enter_email}}</span> -->
                      <input type="text" v-model="userEmail" v-bind:placeholder="user_lang.username" class="input-reinvite" />
                    </div>
                    <div class="col-12 field-reinvite">
                      <!-- <span>{{user_lang.last_name}}</span> -->
                      <input type="text" v-model="userLastName" v-bind:placeholder="user_lang.last_name" class="input-reinvite" />
                    </div>
                  </div>
                </div>
                <div id="captcha_container" style="padding: 10px; width: 100%; text-align: center; margin: 0px auto">
                  <!--div style="text-align:center;position: absolute;padding: 35px 90px;z-index: -99;">Captcha loading...</div-->
                  <vue-recaptcha v-bind:sitekey="sitekey" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired" @render="onRender">
                  </vue-recaptcha>
                </div>
                <div style="padding-left: 10px">
                  <div class="validation-text" v-if="userValidations !== ''">
                    {{ userValidations }}
                  </div>
                </div>
                <div style="padding: 10px">
                  <button style="width: 100%" @click="validateAndResendInvite()" v-bind:class="{ disabled: !captchaVerified }">
                    {{ user_lang.reinvite }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="inviteSuccess" style="text-align: center; padding: 10px; border-top: 1px solid #ccc; padding-top: 20px">
          <div style="display: block; text-align: center">
            <i class="fa fa-check-circle" style="font-size: 50px; color: var(--theme-primary)"></i>
          </div>
          <div>{{ user_lang.reinviteEmailMessage }}</div>
          <div style="padding-top: 20px">
            {{ user_lang.reinviteContactAdminMessage }}
          </div>
        </div>
      </div>
      <div style="max-width: 800px; margin: auto; padding-top: 35px; padding: 50px; background: #fff" v-show="enableRefIdApproach && !tokenInvalid">
        <div style="padding: 10px">
          <!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
	<span class="exclamatory-error-icon">!</span></div-->{{ user_lang.copyrefid }}
        </div>
        <div style="padding: 10px"><input type="text" v-model="refId" /></div>
        <div style="padding: 10px">
          <button @click="getTokenAndRedirect(refId)">Register</button>
        </div>
      </div>
      <div v-show="!tokenInvalid && !enableRefIdApproach && !whitelabelSpecific" class="okta-sign-in-header auth-header">
        <img src="static/1200px-Cargill_logo.svg.png" class="auth-org-logo" alt="" />
      </div>
      <div class="container-fluid" style="background: #fff" v-show="!tokenInvalid && !enableRefIdApproach">
        <div class="title-bar">
          <p class="welcome">
            <span style="color: var(--regpwd-secondarytextcolor); font-size: 15px; font-weight: bold">
              {{ user_lang.welcome_cargill }}
              <span v-show="browserLang != 'uk'">{{ brand }}</span>
            </span>
          </p>
        </div>
        <!--h1>{{user_lang.user_reg}}</h1-->
        <div class="row" id="registrationForm" v-show="!accountsetup">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: #fff">
            <!--div class="card-header" style="background: #040404;color: #fff;">{{user_lang.user_reg}}</div-->
            <div style="max-width: 800px; margin: auto">
              <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto; text-align: left; margin-top: 5px">
                    <span style="font-weight: bold">{{ user_lang.password_placeholder }}</span>
                    <!-- <span class="fa fa-info-circle" v-bind:title="user_lang.phone_inst" v-bind:data-original-title="user_lang.phone_inst" data-toggle="tooltip" data-placement="right" style="padding-left: 5px"></span> -->
                    <div class="row-spacing">
                      <div class="field-spacing">
                        <span>{{ user_lang.enter_new_pwd }}</span>
                        <input :class="borderForInputOne" type="password" v-model="password" style="width: 100%" />
                        <span :class="inputOneHasError"></span>
                      </div>
                      <div v-if="showPasswordError" class="errorwrapper">
                        <span class="pwderror" v-for="i in pwdValidationObj" :key="i">{{ i }}</span>
                      </div>
                      <div class="field-spacing">
                        <span>{{ user_lang.repeat_pwd }}</span>
                        <input :class="borderForInputTwo" type="password" v-model="repeatpassword" style="width: 100%" />
                        <span :class="inputTwoHasError"></span>
                      </div>
                      <div v-if="showPasswordError" class="errorwrapper">
                        <span class="pwderror" v-for="i in repeatPwdValidationObj" :key="i">{{ i }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Security Question -->
              <!-- <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto; text-align: left; margin-bottom: 10px">
                    <span>{{ user_lang.choose_forgot_pwd_qtn }}</span>
                    <select v-model="selectedSecQN" style="width: 100%">
                      <optgroup v-bind:label="user_lang.stock_qtn">
                        <option v-for="sq in listofsecquestions" v-bind:value="sq.question">{{ sq.questionText }}</option>
                      </optgroup>
                      <optgroup v-bind:label="user_lang.custom_qtn">
                        <option value="custom">{{ user_lang.own_sec_qtn }}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="row" style="padding-top: 0px" v-show="selectedSecQN == 'custom'">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto; text-align: left">
                    <span>{{ user_lang.custom_qtn }}</span>
                    <input v-model="custom_question" style="width: 100%" />
                  </div>
                </div>
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto; text-align: left">
                    <span>{{ user_lang.answer }}</span>
                    <input v-model="answer" style="width: 100%" />
                  </div>
                </div>
              </div> -->
              <div
                class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
                style="display: none"
                v-show="(availableFactorID === '' || availableFactorID === undefined) && !isGroupPhone"
              >
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto; text-align: left; margin-top: 5px">
                    <span style="font-weight: bold">{{ user_lang.nop }} {{user_lang.optional}}</span>
                    <span
                      class="fa fa-info-circle"
                      v-bind:title="user_lang.phone_inst"
                      v-bind:data-original-title="user_lang.phone_inst"
                      data-toggle="tooltip"
                      data-placement="right"
                      style="padding-left: 5px"
                    ></span>
                    <div id="phoneModal" class="row-spacing">
                      <!-- second page -->
                      <div style="color: #a7a7a7" class="field-spacing" v-show="codeSent">
                        {{ user_lang.enter_code_rule }}
                      </div>
                      <div v-show="codeSent" id="smsPhoneCodeForm.edit.form" class="m-form verify-code-form clearfix leave-open-on-success">
                        <input
                          type="hidden"
                          class="hide"
                          name="_xsrfToken"
                          value="bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
                        />
                        <input type="hidden" name="smsFactor" value="true" />
                        <input name="activateFactor" value="false" type="hidden" class="hide" />
                        <label
                          id="smsPhoneCodeForm.code.label"
                          for="verifyCode"
                          class="margin-btm-0"
                          path="token"
                          csserrorclass="error"
                          style="display: block"
                          >{{ user_lang.enter_code }}
                        </label>
                        <div class="row" style="padding-right: 10px">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: left; padding-right: 5px">
                            <input v-model="verifycode" id="verifyCode" name="code" class="verify-input" type="text" value="" autocomplete="off" />
                          </div>
                        </div>
                        <div class="row" style="padding-top: 10px">
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="text-align: left; padding-right: 5px">
                            <input
                              v-bind:value="user_lang.verify"
                              name="m-save"
                              type="button"
                              id="smsPhoneCodeForm.button.submit"
                              class="ajax-form-submit verify-sms save button"
                              :class="{ disabled: verifyClicked }"
                              @click="verifySMS()"
                            />
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="text-align: left; padding-right: 5px">
                            <button v-show="codeSent" class="phoneVerification" @click="goBack()">
                              {{ user_lang.back }}
                            </button>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" style="text-align: left">
                            <button v-show="codeSent" class="phoneVerification" @click="cancelVerification()">
                              {{ user_lang.cancel }}
                            </button>
                          </div>
                        </div>
                        <div id="smsPhoneCodeForm.edit.errors" style="padding-top: 5px" class="" v-show="iserror">
                          <div style="padding: 5px; background: rgb(255, 192, 203); padding-left: 15px; margin-top: 5px">
                            <!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
			   <span class="exclamatory-error-icon">!</span></div-->{{ verifyCodeError }}
                          </div>
                        </div>
                      </div>
                      <div class="edit-form clearfix" v-show="!codeSent">
                        <div class="padding-0 margin-0 autowidth float-n normal">
                          <div id="smsPhoneSetupForm.edit.errors" style="display: none" class="infobox infobox-error margin-btm">
                            <span class="icon error-16"></span>
                            <p>Please review the form to correct the following errors</p>
                            <ul class="bullets">
                              <li>
                                <span id="smsPhoneSetupForm.passcode.error"></span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div id="smsPhoneWidget" class="padding-0 margin-0 autowidth float-n"></div>
                        <div>
                          <div class="field-spacing">
                            <div>
                              <span for="countryCode">{{ user_lang.country }}</span>
                              <span
                                class="fa fa-info-circle"
                                v-bind:title="user_lang.country_inst"
                                v-bind:data-original-title="user_lang.country_inst"
                                data-toggle="tooltip"
                                data-placement="right"
                                style="padding-left: 5px"
                              >
                              </span>
                            </div>
                            <div class="clearfix">
                              <select
                                id="countryCode"
                                name="countryCode"
                                v-if="paramLang !== 'es_ES'"
                                v-model="countryCode"
                                style="width: 100%"
                                autocomplete="off"
                              >
                                <option v-for="obj in dropdownList.common" :key="obj.key" :value="obj.key">
                                  {{ user_lang[`${obj.value}`] }}
                                </option>
                              </select>
                              <!-- For Spanish -->
                              <select
                                id="countryCode"
                                name="countryCode"
                                v-if="paramLang === 'es_ES'"
                                v-model="countryCode"
                                style="width: 100%"
                                autocomplete="off"
                              >
                                <option v-for="obj in dropdownList.es" :key="obj.key" :value="obj.key">
                                  {{ user_lang[`${obj.value}`] }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="field-spacing">
                            <div :class="browserLang === 'uk' ? 'margintop' : ''">
                              <span for="phN">{{ user_lang.nopMobile }}</span
                              ><span
                                class="fa fa-info-circle"
                                v-bind:title="user_lang.nop_inst"
                                v-bind:data-original-title="user_lang.nop_inst"
                                data-toggle="tooltip"
                                data-placement="right"
                                style="padding-left: 5px"
                              ></span>
                            </div>
                            <div class="clearfix">
                              <input type="text" id="pn" name="phN" v-model="phN" style="width: 100%" />
                            </div>
                          </div>
                          <div class="field-spacing">
                            <button v-show="!codeSent" v-bind:class="{ disabled: !phN.trim().length }" class="send-code" @click="sendCode()">
                              {{ user_lang.send_code }}
                            </button>
                            <!--button  v-show="codeSent" type="button" class="btn btn-default" style="background:#f9f9f9;color:#595959;border:1px solid #c3c3c3;font-size:13px;"
		  @click = "showPhNoPane = false">{{user_lang.done}}</button-->
                          </div>
                          <div
                            style="padding: 5px 15px; background: #f3db79; border: 1px solid #ffcc12; margin-top: 5px; width: 100%"
                            v-show="isPhoneNoNotVerified"
                          >
                            <i class="fa fa-warning" style="padding: 5px 5px 5px 0px"></i>{{ user_lang.verifyPhoneWarning }}
                          </div>
                          <div class="phone-error" v-show="error30SecOTP == true">
                            <!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
<span class="exclamatory-error-icon">!</span></div-->{{ user_lang.OTPEnableAfter30Sec }}
                          </div>
                          <div class="phone-error" v-show="phoneNumberNotValid == true">
                            <!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
 <span class="exclamatory-error-icon">!</span></div-->{{ user_lang.phonenumberinvalid }}
                          </div>
                          <div class="phone-error" v-show="phoneNoAlreadySet == true">
                            <!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
<span class="exclamatory-error-icon">!</span></div-->{{ user_lang.phoneNoAlreadySet }}
                          </div>
                          <div class="phone-error" v-show="genericErrorMsg">
                            {{ user_lang.msgForUnhandledResponse }}
                          </div>
                        </div>
                        <div class="padding-0 margin-0 autowidth float-n normal">
                          <div id="smsPhoneSetupForm-edit-success" style="display: none" class="infobox infobox-success infobox-md clear margin-top">
                            <span class="icon success-24"></span>
                            <p class="success-text">Phone number successfully verified!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="alreadyRegistered" style="margin-left: 15px; padding: 0px 15px">
                <div class="success-text" style="color: green; font-weight: bold">
                  {{ user_lang.phonealreadyactive }}
                </div>
              </div>
              <div v-show="issuccess" style="margin-left: 15px; padding: 0px 15px">
                <!--p-->
                <span class="success-text" style="color: green; font-weight: bold">{{ user_lang.verify_success }}</span>
                <!--br>{{user_lang.click}} <strong>{{user_lang.done}}</strong>{{user_lang.finish_setup}}</p-->
              </div>
            </div>
            <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div v-if="brand.toLowerCase().indexOf('cargill') == -1">
                <div class="row" v-for="(i, index) in termsArray" :key="index">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <input type="checkbox" v-model="brandtermagree[index]" class="input-terms" />
                    <div class="brand-terms">
                      <span v-html="i"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="brand.toLowerCase().indexOf('cargill') > -1">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <input id="agree1" type="checkbox" v-model="agreeone" class="input-terms" />
                  <div class="brand-terms">
                    <span>{{ user_lang.iread1 }}</span>
                    <a v-bind:href="tclink" target="_blank">{{ user_lang.iread2 }}</a>
                    <span>{{ user_lang.iread3 }}</span>
                  </div>
                </div>
              </div>
              <div class="row" v-if="brand.toLowerCase().indexOf('cargill') > -1">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <input id="agree2" type="checkbox" v-model="agreetwo" class="input-terms" />
                  <div class="brand-terms">
                    <span>{{ user_lang.iagree1 }}</span>
                    <a v-bind:href="pplink" target="_blank">{{ user_lang.iagree2 }}</a>
                    <span>{{ user_lang.iagree3 }}</span>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                style="display: flex; margin-left: auto; margin-right: auto; text-align: left; padding-top: 0px; background: #ffc0cb; margin-top: 5px"
                v-show="errorCode != ''"
              >
                <!--div style="background:#e34843;width:22px; height:auto;"><span class="exclamatory-error-icon">!</span></div-->
                <div style="color: #333; font-size: 13px; padding: 5px">
                  {{ user_lang[errorCode] }}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 offset-md-6 offset-lg-6 col-sm-12 col-xs-12">
                  <div @click="isCheckboxDisabled()" style="display: inline-block">
                    <button
                      class="btn-primary create-acc"
                      v-bind:value="user_lang.create_acc"
                      @click="setUserAccount()"
                      v-bind:class="{
                        disabled:
                          (brand.toLowerCase().indexOf('cargill') > -1 && (!agreeone || !agreetwo)) ||
                          (brand.toLowerCase().indexOf('cargill') == -1 && !(brandtermagree.filter((i) => i == true).length === termsArray.length))
                      }"
                    >
                      {{ user_lang.create_acc }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="congrats" v-show="accountsetup">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: #fff">
          <div style="max-width: 800px; margin: auto">
            <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div style="font-size: 22px; width: 80%; display: inline-block; margin-bottom: 10px">
                {{ internalUser ? user_lang.alreadyactive : user_lang.congrats }}
                <div style="font-size: 16px">
                  {{ internalUser ? user_lang.alreadyactivesetup : user_lang.accountsetup }}
                </div>
              </div>
              <div style="display: inline-block; width: 20%; float: right">
                <i class="fa fa-check-circle" style="font-size: 50px; color: var(--theme-primary)"></i>
              </div>
              <div style="font-size: 16px; width: 80%; display: inline-block; margin-bottom: 10px" v-show="regApps.length !== 0">
                {{ user_lang.gotoapp }}
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps"
                v-for="(i, index) in regApps"
                :key="index"
                @click="goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)"
                :title="i.label"
              >
                <div class="icon-wrap">
                  <img v-bind:src="i._links.logo[0].href" style="max-width: 90px" />
                </div>
                <div>{{ i.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import base64 from 'base-64'
import Spinner from "@/components/Spinner";
// import router from '@/router'
import storage from "../helpers/storage";
import idmApi from "@/idm-api";
import common from "../helpers/common";
import countryDropdownList from "../helpers/country-dropdown-list";
import VueRecaptcha from "vue-recaptcha";
import { locale } from "@/i18n/locale.js";
import { EventBus } from "@/event-bus.js";
import countryCodeConfig from "../helpers/country-code";
import groupPhoneConfig from "../helpers/group-phone";
const islowerCase = "^(?=.*[a-z])";
const isUpperCase = "^(?=.*[A-Z])";
const isNumber = "^(?=.*[0-9])";
const isSpecialChar = "^(?=.*[!@#$%^&*-])";
const isMinLength = "^(?=.{8,})";
const apiUrl = process.env.API_URL;
const APPS_MANDATE_PHONE = process.env.APPS_MANDATE_PHONE;
const SITEKEY = process.env.CAPTCHA_SITEKEY;
// const onecargillappid = process.env.KEY_ID;
// import okta from '@/helpers/okta'
// const brandDetails = require('../brand-details.json');
let environment = process.env.NODE_ENV;
let brandDetails = "";
console.log("env=====", environment);
if (environment === "production") {
  brandDetails = require("../brand-details.json");
} else if (environment === "stage") {
  brandDetails = require("../brand-details-stage.json");
} else {
  brandDetails = require("../brand-details-dev.json");
}
const internalUserDomains = require("../internalUserEmailDomains.json").data;
export default {
  created() {
    this.dropdownList = countryDropdownList.lang;
    console.log(this.dropdownList);
    this.paramLang = this.getParameterByName("lang", document.location.href);
    this.fetchTokenAndInitiate();
    var self = this;
    $(document).on("keypress", "input", function () {
      self.errorCode = "";
      self.userValidations = "";
    });
    $(document).on("keypress", "#pn,#verifyCode", function (evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    });
    // check user language and assign corresponding label object
    // this.user_lang = this.lang_br // lang_br for br portuguese
    setTimeout(self.assignUserLang(), 1000); // lang_br for br portuguese
    EventBus.$on("lang", function (language) {
      self.user_lang = self.lang_obj[language];
      self.lang = language;
    });
    var brand = brandDetails.data.filter((i) => i.applicationUrls.indexOf(document.location.host) > -1);
    if (brand[0].brandCode !== "001") {
      self.whitelabelSpecific = true;
    }
  },
  mounted() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.setDefaultCountry();
    this.getBrandName();
    this.updateCaptchaWithLocale();
  },
  data() {
    return {
      templateLang: "en_US",
      enableRefIdApproach: false,
      refId: "",
      brandDetails: brandDetails,
      brand: "",
      termsArray: [],
      brandtermagree: [],
      tclink: "https://www.cargill.com/portal-terms",
      pplink: "https://www.cargill.com/page/privacy",
      listofsecquestions: [],
      lang: locale.lang,
      lang_obj: locale.lang_obj,
      fetchResponse: "",
      phN: "",
      countryCode: "1",
      token: "",
      userId: "00ud1f5tz9guPug9Z0h7",
      firstName: "",
      lastName: "",
      loginId: "",
      errorCode: "",
      password: "",
      showPhNoPane: false,
      selectedSecQN: "disliked_food",
      repeatpassword: "",
      securityImage: "",
      alreadyRegistered: false,
      answer: "",
      custom_question: "",
      issuccess: false,
      iserror: false,
      verifycode: "",
      factorId: "",
      enableOTPSend: true,
      error30SecOTP: false,
      phoneNumberNotValid: false,
      phoneNoAlreadySet: false,
      tokenInvalid: false,
      pwdValid: false,
      activateFactorId: "",
      factorIdToDelete: "",
      passwordPolicyArray: [],
      currPwdPolicy: {},
      pwdComplexity: {},
      pwdErrorArray: [],
      availableFactorID: null,
      errorMessages: {},
      minAnswerLength: "",
      codeSent: false,
      user_lang: locale.lang_obj["en_US"],
      loading: true,
      accountsetup: false,
      internalUser: false,
      userApps: [],
      regApps: [],
      agreeone: false,
      agreetwo: false,
      isServiceAccountGroupMember: false,
      userEmail: "",
      userLastName: "",
      userValidations: "",
      captchaResponse: "",
      captchaVerified: false,
      inviteSuccess: false,
      isSRCdxp: "",
      sitekey: SITEKEY,
      noTransformEmail: false,
      brandCode: "",
      paramLang: "",
      errorMsg: "",
      localeLang: { uk: "380", fr: "33", ru: "7" },
      defaultLocaleLang: { ph: "63", us: "1", aus: "061" },
      browserLang: "",
      isGroupPhone: false,
      showPasswordError: true,
      whitelabelSpecific: false,
      otpSent: false,
      isPhoneNoNotVerified: false,
      isNetworkError: false,
      verifyCodeError: "",
      verifyClicked: false,
      dropdownList: [],
      genericErrorMsg: false,
      allAvailableFactors: []
    };
  },
  components: {
    Spinner,
    VueRecaptcha
  },
  computed: {
    inputOneHasError() {
      if (this.password.length === 0) {
        return "";
      }
      return this.pwdValidationObj.length !== 0 ? "invalid fa fa-exclamation-circle" : "valid fa fa-check-circle";
    },
    inputTwoHasError() {
      if (this.repeatpassword.length === 0) {
        return "";
      }
      return this.repeatPwdValidationObj.length !== 0 ? "invalid fa fa-exclamation-circle" : "valid fa fa-check-circle";
    },
    borderForInputOne() {
      if (this.password.length === 0) {
        return "";
      }
      return this.pwdValidationObj.length !== 0 ? "red-border" : "green-border";
    },
    borderForInputTwo() {
      if (this.repeatpassword.length === 0) {
        return "";
      }
      return this.repeatPwdValidationObj.length !== 0 ? "red-border" : "green-border";
    },
    // var regexStr = '^'+isNumber+isMinLength
    // var pwdRegex = new RegExp(regexStr)
    pwdValidationObj: function () {
      var errors = [];
      var minCharRegex = isMinLength.replace("8", this.pwdComplexity.minLength);
      if (this.password.trim().length > 0) {
        if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
          errors.push(this.user_lang.noLowerCase);
        }
        if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
          errors.push(this.user_lang.noUpperCase);
        }
        if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
          errors.push(this.user_lang.noNumber);
        }
        if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
          errors.push(this.user_lang.noSpecialCharacter);
        }
        if (!this.password.trim().match(new RegExp(minCharRegex))) {
          errors.push(this.user_lang.notMinLength.replace("$", this.pwdComplexity.minLength));
        }
        if (
          this.pwdComplexity.excludeAttributes !== undefined &&
          this.pwdComplexity.excludeAttributes.includes("lastName") &&
          this.password.trim().indexOf(this.lastName) !== -1
        ) {
          errors.push(this.user_lang.noLastnameSubstring);
        }
        if (
          this.pwdComplexity.excludeAttributes !== undefined &&
          this.pwdComplexity.excludeAttributes.includes("firstName") &&
          this.password.trim().indexOf(this.firstName) !== -1
        ) {
          errors.push(this.user_lang.noFirstnameSubstring);
        }
        if (this.pwdComplexity.excludeUsername && this.loginId.indexOf(this.password.trim()) > -1) {
          errors.push(this.user_lang.noUsernameSubstring);
        }
        if (errors.length === 0) {
          this.pwdValid = true;
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    },
    repeatPwdValidationObj: function () {
      var errors = [];
      if (this.repeatpassword.trim().length > 0) {
        if (this.password.trim() !== this.repeatpassword.trim()) {
          errors.push(this.user_lang.passwordnotmatching);
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    }
  },
  watch: {
    phN: function () {
      this.watchphN();
    },
    agreeone: function () {
      this.watchAgreeTerms();
    },
    agreetwo: function () {
      this.watchAgreeTerms();
    },
    brandtermagree: function () {
      this.watchAgreeTerms();
    }
  },
  methods: {
    detectBrowser: function () {
      var isBrowserSpecific = false;
      var userAgent = navigator.userAgent;
      var ieMode = document.documentMode;
      if (ieMode && userAgent.match(/(MSIE|Trident)/)) {
        isBrowserSpecific = true;
      } else if (
        navigator.vendor &&
        navigator.vendor.indexOf("Apple") > -1 &&
        userAgent &&
        userAgent.indexOf("CriOS") === -1 &&
        userAgent.indexOf("FxiOS") === -1
      ) {
        // Safari browser
        var version = 0;
        if (userAgent.indexOf("Version") > -1) {
          version = parseInt(userAgent.split("Version/")[1].split(" ")[0], 10); // Safari v
        }
        if (navigator.platform.indexOf("Mac") > -1) {
          // macOS
          if (userAgent.split("OS X ")[1] && userAgent.split("OS X ")[1].split(" ")[0].indexOf("10_9") > -1 && version >= 7 && version < 8) {
            // Safari 7
            isBrowserSpecific = true;
          } else if (userAgent.split("OS X ")[1] && userAgent.split("OS X ")[1].split(" ")[0].indexOf("10_10") > -1 && version >= 8 && version < 9) {
            // Safari 8
            isBrowserSpecific = true;
          }
        } else if (
          ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
          (userAgent.includes("Mac") && "ontouchend" in document)
        ) {
          // iOS
          if (version >= 6 && version < 7) {
            // Safari 6
            isBrowserSpecific = true;
          } else if (version >= 7 && version < 8) {
            // Safari 7
            isBrowserSpecific = true;
          } else if (version >= 8 && version < 9) {
            // Safari 8
            isBrowserSpecific = true;
          }
        }
      }
      return isBrowserSpecific;
    },
    errorModalClick: function () {
      var self = this;
      $(".errorModal").modal("hide");
      self.showPasswordError = true;
    },
    countryCodeDefaultBasedOnGroups: function (groups) {
      var self = this;
      var commonGroups = [];
      groups.forEach((group) => {
        var groupName = countryCodeConfig.getGroup(group.profile.name);
        if (groupName.length > 0) {
          commonGroups.push(groupName[0]);
        }
      });
      if (commonGroups.length > 1) {
        self.countryCode = self.defaultLocaleLang["us"];
      } else if (commonGroups.length === 1) {
        self.countryCode = self.defaultLocaleLang[commonGroups[0].lang];
        if (self.templateLang === 'es_ES' && commonGroups[0].lang === "aus") {
          self.countryCode = "61";
        }
      }
      console.log("Common Groups: ", commonGroups);
    },
    setDefaultCountry: function () {
      const browserLang = window.navigator.language;
      this.browserLang = browserLang;
      if (browserLang === "uk" || browserLang === "fr" || browserLang === "ru") {
        this.countryCode = this.localeLang[browserLang];
      }
      if (this.templateLang && this.templateLang.toLowerCase() === "ko_kr") {
        this.countryCode = "82"
      }
    },
    updateCaptchaWithLocale: function () {
      // Get GoogleCaptcha iframe
      let iframeGoogleCaptcha = $("#captcha_container").find("iframe");
      let lang = common.getLanguage(this.paramLang);
      if (lang === "zh_TW") {
        lang = "bg";
      }
      lang = lang.replace("_", "-");
      if (iframeGoogleCaptcha && iframeGoogleCaptcha.length > 0) {
        iframeGoogleCaptcha.attr("src", iframeGoogleCaptcha.attr("src").replace(/hl=(.*?)&/, "hl=" + lang + "&"));
      }
    },
    getParameterByName: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    watchphN() {
      var self = this;
      self.isPhoneNoNotVerified = self.phN.length > 0;
      if (self.countryCode === "1") {
        var x = self.phN.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        self.phN = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      } else if (self.countryCode === "061" && self.phN.length > 10) {
        self.phN = self.phN.slice(0, 10);
      }
    },
    watchAgreeTerms() {
      var self = this;
      if ((self.agreeone || self.agreetwo) && self.errorCode.indexOf("acceptTerms") > -1) {
        self.errorCode = "";
      }
      if (self.brandtermagree.some((x) => x === true) && self.errorCode.indexOf("acceptTerms") > -1) {
        self.errorCode = "";
      }
    },
    assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    goToApp(url) {
      window.open(url, "_blank");
    },
    getPasswordPolicy() {
      var self = this;
      self.loading = true;
      idmApi.getPasswordPolicy(`${apiUrl}/policies`, self.token).then(function (response) {
        self.passwordPolicyArray = response.data;
        if (self.passwordPolicyArray.length === 1) {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === "Default Policy") return i;
          });
        } else {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === "Legacy Policy") return i;
          });
        }
        self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity;
        self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength;
        self.loading = false;
      });
    },
    /* handleRedirect () {
        var self = this
        idmApi.getActiveAppNames(`${apiUrl}/apps/${this.userId}`, self.token).then(function (response) {
          // window.location.href = redirectUrl + '?fromUserReg=true'
          if (response.data.length === 0) { // No application assigned
            // window.location.href = "https://cargillcustomer-qa.oktapreview.com/welcome/" + self.token
          }
          var onecargillappurl = ''
          var urls = response.data.map(function (item) {
            if (item.name !== "bookmark" && item.id !== onecargillappid) { // if assigned to Brazil app
              return item.settings.oauthClient.initiate_login_uri
            }
            if (item.id === onecargillappid) onecargillappurl = item.settings.oauthClient.initiate_login_uri
          })
          if (urls.length || urls[0] !== undefined) window.location.href = urls[0]
          else window.location.href = onecargillappurl
        })
      }, */
    isCheckboxDisabled() {
      var self = this;
      if (self.brand.toLowerCase() === "cargill") {
        if (!self.agreeone || !self.agreetwo) {
          self.errorCode = "acceptTerms";
        }
      } else {
        if (self.brandtermagree.filter((x) => x === true).length !== self.termsArray.length) {
          self.errorCode = "acceptTerms";
        }
      }
    },
    setUserAccount() {
      var self = this;
      self.loading = true;
      self.errorCode = "";
      $(".errorModal").modal("hide");
      self.showPasswordError = true;
      if (this.validateSetUser() && this.validatePhoneNumberCheck()) {
        // Removed validateCustomAndNormalSecAnswerWeakness() for Security Question
        let data = {
          credentials: {
            password: {
              value: this.password
            } /*,
              "recovery_question": {
                "question": this.selectedSecQN === 'custom' ? this.custom_question : (this.listofsecquestions.filter(x => x.question === this.selectedSecQN)[0]).questionText,
                "answer": this.answer
              } */
          }
        };
        idmApi
          .setUserAccount(`${apiUrl}/users/${self.userId}`, data, self.token)
          .then(function (response) {
            self.loading = false;
            if (response.data.status === "ACTIVE") {
              // okta.oktaSignOut();
              storage.clearAll();
              self.accountsetup = true;
              // window.location.href = "http://localhost:8080/Login"
              // storage.set('email', response.data.profile.login ? response.data[0]._embedded.user.profile.login : response.data[0]._embedded.user.profile.email)
              // storage.set('key', base64.encode(self.password))
            } else {
              // error handling
            }
          })
          .catch((error) => {
            console.log(error);
            if (
              error.response.data &&
              error.response.data.errorCauses &&
              error.response.data.errorCauses.length &&
              error.response.data.errorCauses[0].errorSummary
            ) {
              let errorSummary = error.response.data.errorCauses[0].errorSummary;
              $(".errorModal").modal("show");
              self.showPasswordError = false;
              if (errorSummary.indexOf("password") !== -1) {
                self.errorMsg = self.user_lang.phoneValidationErrorMessage;
              } else if (errorSummary.indexOf("securityAnswer") !== -1) {
                self.errorMsg = self.user_lang.securityquestionanswerweak;
              } else {
                self.errorMsg = error.response.data.errorCauses[0].errorSummary;
              }
              self.loading = false;
            }
            self.loading = false;
          });
      } else {
        self.loading = false;
      }
    },
    fetchTokenAndInitiate() {
      var self = this;
      var actToken = this.getParameterByName("activationToken", document.location.href);
      this.templateLang = this.getParameterByName("lang", document.location.href);
      this.isSRCdxp = this.getParameterByName("src", document.location.href);
      if (actToken === null || actToken === undefined || actToken.trim() === "") {
        this.setUserLocale(self.templateLang);
        this.enableRefIdApproach = true;
        this.loading = false;
        setTimeout(function () {
          $(".splash").removeClass("hiddden");
          $("#userRegistration").css("display", "block");
        }, 500);
      } else {
        this.getTokenAndRedirect(actToken);
      }
    },
    getTokenAndRedirect(token) {
      var self = this;
      self.loading = true;
      this.setDefaultCountry();
      self.token = token !== null && token !== undefined ? token.trim() : "";
      self.enableRefIdApproach = false;
      self.tokenInvalid = false;
      let data = { recoveryToken: self.token };
      // window.history.replaceState(null, "", document.location.href.split("?")[0]);
      idmApi
        .getUserIdByToken(`${apiUrl}/recovery/token`, data)
        .then(function (response) {
          self.loading = true;
          $("#userRegistration").css("display", "block");
          var responseObj = response.data;
          // self.pwdComplexity = responseObj._embedded.policy.complexity
          self.userId = responseObj._embedded.user.id;
          // self.checkPhoneNumber()
          self.firstName = responseObj._embedded.user.profile.firstName;
          self.lastName = responseObj._embedded.user.profile.lastName;
          self.loginId = responseObj._embedded.user.profile.login
            ? responseObj._embedded.user.profile.login
            : responseObj._embedded.user.profile.email;
          self.getBrandName(self.loginId);
          // self.getPasswordPolicy();
          idmApi.getActiveAppNames(`${apiUrl}/apps/${self.userId}`, self.token).then(function (response) {
            self.userApps = response.data;
            self.loading = false;
            self.regApps = response.data.filter(function (item) {
              if (item.name.toLowerCase() !== "oidc_client" && !item.visibility.hide.web) {
                return item;
              }
            });
          });
          self.loading = true;
          idmApi
            .getGroupsByUserId(`${apiUrl}/users/${self.userId}/groups`, self.token)
            .then(function (response) {
              self.countryCodeDefaultBasedOnGroups(response.data);
              self.isGroupPhone = self.setGroupBasedPhone(response.data)
              console.log("isGroupPhone" + self.isGroupPhone)
              self.isServiceAccountGroupMember =
                response.data.filter(
                  (x) =>
                    x.profile.name.toLowerCase().indexOf("service accounts") > -1 ||
                    x.profile.name.toLowerCase().indexOf("brazilian portalapp") > -1 ||
                    x.profile.name.toLowerCase().indexOf("cargillonlinefeed") > -1 ||
                    x.profile.name.toLowerCase().indexOf("cargillonlinefeedusers") > -1 ||
                    x.profile.name.toLowerCase().indexOf("crm velo salesforce") > -1
                ).length > 0;
              idmApi
                .getUserIdByEmail(`${apiUrl}/users/${self.userId}`, self.token)
                .then(function (response) {
                  self.loading = false;
                  self.setUserLocale(response.data.profile.locale);
                  var emailDomain = self.loginId.split("@").length > 1 ? self.loginId.split("@")[1] : "";
                  if (
                    !self.isServiceAccountGroupMember &&
                    internalUserDomains.filter((x) => x.toLowerCase().indexOf(emailDomain.toLowerCase()) > -1).length > 0
                  ) {
                    self.accountsetup = true;
                    self.internalUser = true;
                    self.loading = false;
                    return;
                  }
                  if (response.data.credentials.provider.type.toLowerCase() === "federation" && !self.isServiceAccountGroupMember) {
                    self.accountsetup = true;
                  } else {
                    self.getPasswordPolicy();
                    self.checkPhoneNumber();
                  }
                  if (self.isServiceAccountGroupMember) {
                    self.getPasswordPolicy();
                    self.checkPhoneNumber();
                  }
                })
                .catch((err) => {
                  self.loading = false;
                  console.log("create Insert CF Error: ", err);
                });
            })
            .catch((err) => {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
        })
        .catch((error) => {
          $("#userRegistration").css("display", "block");
          self.setUserLocale(self.templateLang, false);
          // self.getBrandBg();
          self.getBrandName(self.loginId);
          if (error.response.status === 401 || error.response.status === 403) {
            self.loading = false;
            self.tokenInvalid = true;
            self.enableRefIdApproach = false;
          } else {
            if (error.toString().toLowerCase().indexOf("network error") > -1) {
              console.log("Network Error. please check your connection");
            }
            self.loading = false;
            self.tokenInvalid = true;
            self.enableRefIdApproach = false;
            self.isNetworkError = true;
          }
        });
    },
    getBrandBg() {
      var self = this;
      console.log(self.brandDetails);
      var brand = self.brandDetails.data.filter((n) => n.applicationUrls.indexOf(document.location.host) > -1);
      if (brand.length && brand[0].bgImageLink.trim() !== "") {
        $(".splash").attr("src", brand[0].bgImageLink);
      }
      setTimeout($(".splash").removeClass("hiddden"), 500);
    },
    getBrandName(email) {
      var self = this;
      var bd = self.brandDetails.data.filter((n) => n.applicationUrls.indexOf(document.location.host) > -1)[0];
      // if (email.toLowerCase().indexOf('@identity.mycargill.com') > -1 || email.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || email.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
      //   bd = self.brandDetails.data.filter(n => n.brandCode.toLowerCase() === email.substr(2, 3))[0]
      // }
      self.brand = bd.brandName;
      self.termsArray = bd.terms;
      self.noTransformEmail = bd.noTranform;
      self.brandCode = bd.brandCode;
      self.tclink = bd.termsandconditionslink;
      self.pplink = bd.privacypolicylink;
      var bgimg = bd.bgImageLink.trim();
      if (bgimg !== "") {
        if (bgimg.indexOf("#") !== 0) {
          $(".splash").attr("src", bgimg);
        } else {
          $(".splash").attr("src", ""); // //:0
          $(".splash").css("background", bgimg);
        }
      }
      setTimeout($(".splash").removeClass("hiddden"), 500);
      /* if (bd.themeColor.trim() === '') {
          bd.themeColor = '#e7efef'
        }
        if (bd.themeButtonColor.trim() === '') {
          bd.themeButtonColor = 'var(--theme-primary)'
        }
        $('.welcome').css('background', bd.themeColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('background-color', bd.themeButtonColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('border-color', bd.themeButtonColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('color', bd.themeButtonTextColor)
        $('.fa-check-circle').css('color', bd.themeButtonColor) */
    },
    /* validateCustomAndNormalSecAnswerWeakness () {
        var self = this
        var question = self.selectedSecQN === 'custom' ? self.custom_question.trim().toLowerCase() : self.listofsecquestions.filter(x => x.question === self.selectedSecQN)[0].questionText
        question = question.replace('?', '')
        console.log(question)
        var questionWordsArray = question.trim().toLowerCase().split(' ')
        console.log(questionWordsArray)
        var answerWordsArray = self.answer.trim().toLowerCase().split(' ')
        console.log(answerWordsArray)
        var isWeak = questionWordsArray.some(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
        if (isWeak) {
          var term = questionWordsArray.filter(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
          console.log(term)
          self.user_lang.securityanswermatchesquestion = self.user_lang.copysecurityanswermatchesquestion.replace('$', "\"" + term + "\"")
          this.errorCode = 'securityanswermatchesquestion'
          return false
        } else {
          this.errorCode = ''
          return true
        }
      }, */
    validatePhoneNumberCheck() {
      if ((this.otpSent && this.issuccess) || !this.otpSent) {
        return true;
      } else {
        this.errorCode = "phonenumbermissing";
        return false;
      }
    },
    validateSetUser() {
      // const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/  // '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'
      if (this.password.trim() !== "") {
        if (this.password.trim().length) {
          if (this.pwdErrorArray.length === 0) {
            if (this.password.trim() === this.repeatpassword.trim()) {
              // if (this.answer.trim().length >= this.minAnswerLength) {
              // if ((this.userApps.length === 0) || (this.userApps.length > 0 &&
              // this.userApps.filter(i => i.label.toLowerCase().indexOf('gda') > -1).length === 0) ||
              // ((this.userApps.length > 0 && this.userApps.filter(i => i.label.toLowerCase().indexOf('gda') > -1).length > 0) &&
              // (this.issuccess || this.availableFactorID !== '' || this.alreadyRegistered))) { //eslint-disable-line
              if (this.isPhoneNoNotVerified && this.brand.toLowerCase() === "cargill") {
                this.errorCode = "phoneVerificationNotCompleted";
                return false;
              }
              if (this.issuccess || this.availableFactorID !== "" || this.alreadyRegistered) {
                if (this.selectedSecQN === "custom" && this.custom_question.trim() === "") {
                  this.errorCode = "customQuestionEmpty";
                  return false;
                } else {
                  if (this.selectedSecQN === "custom" && this.custom_question.trim() === this.answer.trim()) {
                    this.errorCode = "customQAsame";
                    return false;
                  } else {
                    this.errorCode = "";
                    return true;
                  }
                }
              } else {
                if (this.brand.toLowerCase() === "cargill") {
                  this.errorCode = "";
                  return true;
                } else {
                  this.errorCode = "phonenumbermissing";
                  return false;
                }
              }
              // } else {
              //   this.user_lang.answerlength = this.user_lang.answerlength.replace('$', this.minAnswerLength)
              //   this.errorCode = 'answerlength'
              //   return false
              // }
            } else {
              this.errorCode = "passwordnotmatching";
              return false;
            }
          } else {
            this.errorCode = "passwordnotvalid";
            return false;
          }
        } else {
          this.errorCode = "passwordlength";
          return false;
        }
      } else {
        this.errorCode = "emptypassword";
        return false;
      }
    },
    isPhoneMandatory() {
      var appsToMandatePhone = APPS_MANDATE_PHONE.map((x) => x.toLowerCase());
      return !this.userApps.some((i) => appsToMandatePhone.indexOf(i.id.toLowerCase()) > -1);
    },
    sendCodeNotActive(response) {
      var self = this;
      self.alreadyRegistered = false;
      self.codeSent = true;
      self.verifycode = "";
      self.factorId = response.data.id;
    },
    cancelVerification() {
      var self = this;
      self.loading = true;
      idmApi
        .deleteSMSFactor(`${apiUrl}/users/${self.userId}/factors/${self.factorId}`, self.token)
        .then(function (response) {
          self.loading = false;
          self.otpSent = false;
          self.codeSent = false;
          self.errorCode = "";
          self.phN = "";
          self.countryCode = "1";
          console.log(response);
        })
        .catch((error) => {
          self.loading = false;
          console.log(error.response.status + " " + error.response.data);
          // if (error.response.status === 404) {
          //   self.handle404Error(data)
          // }
        });
    },
    sendCode() {
      var self = this;
      self.error30SecOTP = false;
      self.phoneNumberNotValid = false;
      self.phoneNoAlreadySet = false;
      self.iserror = false;
      self.genericErrorMsg = false;
      let data = {
        factorType: "sms",
        provider: "OKTA",
        profile: {
          phoneNumber: "+" + this.countryCode.replace(/^0+/, "") + this.phN.replace(/\D/g, "")
        }
      };
      self.loading = true;
      idmApi
        .sendCode(`${apiUrl}/users/${self.userId}/factors?updatePhone=true`, data, self.token)
        .then(function (response) {
          self.isPhoneNoNotVerified = false;
          self.loading = false;
          if (response.data.status.toLowerCase() === "active") {
            self.alreadyRegistered = true;
            self.iserror = false;
            // self.issuccess = true
            self.factorId = response.data.id;
            self.errorCode = false;
          } else {
            self.otpSent = true;
            self.sendCodeNotActive(response);
          }
        })
        .catch((error) => {
          self.loading = false;
          let obj = {}
          obj.response = error.response.data
          obj.url = error.response.config.url
          obj.status = error.response.status
          self.sendMessageToDatadog("Send SMS Code", {})
          self.sendMessageToDatadog("Error Response: ", obj)
          self.sendCodeErrorHandler(error);
        });
    },
    sendCodeErrorHandler(error) {
      console.log(error);
      var self = this;
      if (error.response.status === 429) {
        self.error30SecOTP = true;
        self.alreadyRegistered = false;
      } else if (error.response.status === 400) {
        self.handle400Error(error);
      } else {
        self.genericErrorMsg = true;
      }
    },
    handle400Error(error) {
      var self = this;
      // self.checkPhoneNumber()
      // self.phoneNoAlreadySet = true
      if (
        (error.response.data.errorSummary && error.response.data.errorSummary.indexOf("invalid") > -1) ||
        (error.response.data.errorCauses.length > 0 && error.response.data.errorCauses[0].errorSummary.toLowerCase().indexOf("invalid") > -1)
      ) {
        self.phoneNumberNotValid = true;
        self.loading = false;
        return;
      }
      if (error.response.data.errorSummary && error.response.data.errorSummary.toLowerCase().indexOf("factor service error") > -1) {
        self.phoneNumberNotValid = true;
        self.loading = false;
        return;
      }
      if (
        error.response.data.errorCauses.length > 0 &&
        error.response.data.errorCauses[0].errorSummary.toLowerCase().indexOf("already set up") > -1
      ) {
        self.alreadyRegistered = false;
        self.loading = true;
        idmApi
          .getFactorByUserId(`${apiUrl}/users/${self.userId}/factors`, self.token)
          .then(function (response) {
            self.loading = false;
            console.log(response.data);
            let factor = response.data.filter((x) => x.factorType === "sms")[0];
            if (!factor) {
              self.genericErrorMsg = true;
              return;
            }
            self.factorIdToDelete = factor.id;
            self.loading = true;
            idmApi
              .deleteSMSFactor(`${apiUrl}/users/${self.userId}/factors/${self.factorIdToDelete}`, self.token)
              .then(function (response) {
                self.loading = false;
                self.sendCode();
              })
              .catch((error) => {
                self.loading = false;
                self.genericErrorMsg = true;
                console.log(error);
              });
          })
          .catch((error) => {
            self.loading = false;
            self.genericErrorMsg = true;
            console.log(error);
          });
        return;
      }
      self.genericErrorMsg = true;
    },
    goBack() {
      this.codeSent = false;
    },
    verifySMS() {
      var self = this;
      self.verifyClicked = true;
      if (self.verifycode.length === 0) {
        self.iserror = true;
        self.verifyCodeError = self.user_lang["passcodeNotEntered"];
        self.verifyClicked = false;
        return;
      }
      let data = { passCode: self.verifycode };
      self.loading = true;
      idmApi
        .verifyPasscodeOnFactorSetting(`${apiUrl}/users/${self.userId}/factors/${self.factorId}/activate`, data, self.token)
        .then(function (response) {
          self.activateFactorId = response.data.id;
          self.loading = false;
          self.verifyClicked = false;
          if (response.data.status === "ACTIVE") {
            self.iserror = false;
            self.issuccess = true;
            self.errorCode = false;
            self.availableFactorID = response.data.id;
          } else {
            self.iserror = true;
            // self.codeSent = false;
            self.verifyCodeError = self.user_lang["passcodeNotValid"];
            self.sendMessageToDatadog("Verify SMS Code", {})
            self.sendMessageToDatadog("Success Response but not Active: ", response)
          }
        })
        .catch((error) => {
          console.log(error);
          self.sendMessageToDatadog("Verify SMS Code", {})
          self.sendMessageToDatadog("Error Response: ", error)
          self.loading = false;
          self.verifyClicked = false;
          self.iserror = true;
          if (error.response.status === 403) {
            self.verifyCodeError = self.user_lang["passcodeNotValid"];
          } else if (error.response.status === 429) {
            self.verifyCodeError = self.user_lang["passcodeRateLimit"];
          } else {
            self.verifyCodeError = self.user_lang["msgForUnhandledResponse"];
          }
          // self.codeSent = false;
        });
    },
    sendMessageToDatadog(message, data) {
      let url = `${apiUrl}/dataDogMessage?message=${message}`
      idmApi.sendMessageToDatadog(url, data).then(function (response) {
        console.log(response)
      }).catch(function (error) {
        console.log(error)
      })
    },
    checkPhoneNumber() {
      var self = this;
      self.loading = true;
      idmApi.getFactorByUserId(`${apiUrl}/users/${self.userId}/factors`, self.token).then(function (response) {
        self.loading = false;
        self.allAvailableFactors = response.data;
        if (response.data.length > 0) {
          self.availableFactorID = self.allAvailableFactors.filter((x) => x.factorType === "sms" && x.status.toLowerCase() === "active")[0];
        } else {
          self.availableFactorID = "";
        }
      });
    },
    setGroupBasedPhone(groups) {
      var phoneGroups = [];
      groups.forEach((group) => {
        if (groupPhoneConfig.getGroupPh(group.profile.name)) {
          phoneGroups.push(group);
        }
        console.log("groupPhName Groups: ", phoneGroups);
      });
      if (phoneGroups.length > 0) {
        return true
      } else {
        return false
      }
    },
    setLangCookie(lang) {
      const landCode = lang.split("_");
      document.cookie = "lang=" + landCode[0];
    },
    setUserLocale(val, istokenvalid) {
      var self = this;
      // idmApi.getUserIdByEmail(`${apiUrl}/users/${loginId}`).then(function (response) {
      self.loading = false;
      let profileLang = val;
      let checkLang = "";
      let emitTemplate = "en_US";
      if (profileLang !== undefined) {
        // to test change in language setting to vietnamese in okta it is spanish
        if (profileLang !== null && profileLang.trim() !== "") {
          profileLang = common.getLanguage(profileLang);
          Object.keys(locale.lang_obj).forEach(function (i) {
            checkLang = common.getLanguage(i);
            if (checkLang === profileLang) {
              locale.lang = i;
              emitTemplate = i;
            }
          });
          EventBus.$emit("lang", emitTemplate);
          storage.set("user-lang", emitTemplate);
          this.setLangCookie(emitTemplate);
        } else {
          locale.lang = "en_US";
          EventBus.$emit("lang", "en_US");
          storage.set("user-lang", "en_US");
          this.setLangCookie("en_US");
        }
        if (istokenvalid !== false) {
          /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
        }
      } else {
        locale.lang = "en_US";
        storage.set("user-lang", "en_US");
        this.setLangCookie("en_US");
        EventBus.$emit("lang", "en_US");
        if (istokenvalid !== false) {
          /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
        }
      }
      // })
    },
    changeUserLang: function (e) {
      locale.lang = e.target.value;
      this.user_lang = this.lang_obj[e.target.value];
      EventBus.$emit("lang", e.target.value);
    },
    onVerify(resp) {
      var self = this;
      console.log(resp);
      self.captchaResponse = resp;
      var response = window.grecaptcha.getResponse();
      if (response.length !== 0) {
        self.captchaVerified = true;
      }
    },
    onExpired(resp) {
      var self = this;
      console.log(resp);
      self.captchaVerified = false;
    },
    onRender(id) {
      setTimeout(function () {
        console.log(id);
        window.grecaptcha.reset();
      }, 1000);
    },
    validEmail: function (email) {
      var re =
        /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    validateAndResendInvite() {
      var self = this;
      self.userValidations = "";
      if (this.userEmail.trim() === "") {
        self.userValidations = self.user_lang["emailreq"];
      } else if (!this.validEmail(this.userEmail.trim())) {
        self.userValidations = self.user_lang["emailinvalid"];
      } else if (self.userLastName.trim() === "") {
        self.userValidations = self.user_lang["lastnamereq"];
      } else if (!self.captchaVerified) {
        self.userValidations = "Please verify captcha";
      } else {
        let data = {};
        if (self.noTransformEmail !== true) {
          self.userEmail =
            ("0" + (self.userEmail.indexOf("@") + 1)).slice(-2) +
            self.brandCode +
            self.userEmail.split("@").join("") +
            "@partneridentity.okta-emea.com";
        }
        var url = `${apiUrl}/reInvite?userId=${self.userEmail}&lastName=${self.userLastName}`;
        if (self.isSRCdxp !== null && self.isSRCdxp.trim() !== "" && self.templateLang !== null && self.templateLang.trim() !== "") {
          url = url + `&src=${self.isSRCdxp}&lang=${self.templateLang}`;
        }
        idmApi
          .validateUserDetails(`${url}`, data, self.token)
          .then(function (response) {
            console.log(response);
            self.inviteSuccess = true;
          })
          .catch((error) => {
            console.log(error.response);
            self.inviteSuccess = true;
            /* if (error.response && error.response.data && (error.response.status === 406 || error.response.status === 404)) {
              self.userValidations = error.response.data.errorSummary
            } else {
              self.userValidations = "Something went wrong. please try again later"
            } */
          });
      }
    }
  }
};
</script>
<style scoped>
.hiddden {
  visibility: hidden;
}
.welcome {
  background: var(--regpwd-topnavbarbg);
  text-align: center;
  padding: 10px;
  margin-bottom: 5px;
}
.custom-select {
  display: inline-block;
  max-width: 100%;
  height: calc(2.5rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.25;
  background-color: #ececeb;
  vertical-align: middle;
  background-size: 8px 10px;
  border: 1px solid #00524a;
  border-radius: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.card-block {
  background: var(--theme-primary);
  border: 1px solid #00524a;
}
input {
  background: #fff;
}
input,
select {
  height: 30px;
  color: #333;
  margin-top: 2px;
}
.password-rule {
  color: #666;
  font-size: 12px;
  display: block;
  line-height: 16px;
}
.setup-section {
  background: #fff;
  /*border-radius:8px;border: 1px solid #ccc; margin-left: auto;margin-right: auto;text-align: left;padding-bottom: 20px;margin-bottom: 20px;font-size:14px;*/
  font-size: 13px;
  margin-bottom: 5px;
}
label > input {
  /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
label > input + img {
  /* IMAGE STYLES */
  cursor: pointer;
  border: 2px solid #ddd;
}
label > input:checked + img {
  /* (RADIO CHECKED) IMAGE STYLES */
  border: 2px solid #333;
  border-radius: 0px;
}
.exclamatory-error-icon {
  color: #e34843;
  background: #ffffff;
  border-radius: 20px;
  width: 16px;
  height: 16px;
  display: block;
  margin: 5px 3px;
  padding-left: 5px;
  line-height: 16px;
  font-weight: bold;
}
.checked-icon {
  background: #333;
  padding: 3px;
  border-radius: 3px;
}
.checked-icon-container {
  position: absolute;
  margin: 10px;
}
.infobox-before-common,
.infobox::before,
.infobox-md::before,
.infobox-compact::before {
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  content: "";
}
/* line 18, target/sass/courage/infobox/_all.scss */
.infobox {
  position: relative;
  min-height: 18px;
  padding: 12px 18px 12px 48px !important;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  word-break: break-word;
}
/* line 25, target/sass/courage/infobox/_all.scss */
.infobox::before {
  width: 36px;
  background-color: #007dc1;
}
/* line 31, target/sass/courage/infobox/_all.scss */
.infobox.infobox-no-icon {
  padding-left: 24px !important;
}
/* line 34, target/sass/courage/infobox/_all.scss */
.infobox.infobox-no-icon::before {
  display: none;
}
/* line 39, target/sass/courage/infobox/_all.scss */
.infobox > .icon {
  position: absolute;
  top: 13px;
  left: 9px;
}
/* line 45, target/sass/courage/infobox/_all.scss */
.infobox a {
  line-height: 18px;
}
/* line 49, target/sass/courage/infobox/_all.scss */
.infobox ul {
  margin-right: 0;
}
/* line 54, target/sass/courage/infobox/_all.scss */
.infobox .link-button {
  line-height: 28px;
}
/* line 58, target/sass/courage/infobox/_all.scss */
.infobox + .infobox,
.infobox + h2 {
  margin-top: 18px;
}
/* line 63, target/sass/courage/infobox/_all.scss */
.infobox .two_col_left {
  width: 80%;
}
/* line 67, target/sass/courage/infobox/_all.scss */
.infobox .two_col_right {
  width: 19%;
  margin-left: 1%;
  padding-left: 0;
}
/* line 72, target/sass/courage/infobox/_all.scss */
.infobox .two_col_right .button-primary {
  width: 100% !important;
  float: right;
  box-sizing: border-box;
}
/* line 80, target/sass/courage/infobox/_all.scss */
.infobox[style="display: none;"] + .infobox,
.infobox[style="display:none;"] + .infobox {
  margin-top: 0;
}
/* line 85, target/sass/courage/infobox/_all.scss */
.infobox h2,
.infobox h3,
.infobox h2 *,
.infobox h3 * {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}
/* line 96, target/sass/courage/infobox/_all.scss */
.infobox h2 span,
.infobox h3 span {
  color: #5e5e5e;
}
/* line 101, target/sass/courage/infobox/_all.scss */
.infobox h2 + *,
.infobox h3 + *,
.infobox p + *,
.infobox ul + *,
.infobox ol + *,
.infobox li + * {
  margin-top: 9px;
}
/* line 116, target/sass/courage/infobox/_all.scss */
.infobox,
.infobox-md {
  border: 1px solid #ddd;
  border-radius: 3px;
  background-color: #fbfbfb;
}
/* line 124, target/sass/courage/infobox/_all.scss */
.infobox-md {
  min-height: 18px;
  padding: 24px 24px 24px 70px !important;
}
/* line 128, target/sass/courage/infobox/_all.scss */
.infobox-md h2,
.infobox-md h3 {
  font-size: 15px;
}
/* line 132, target/sass/courage/infobox/_all.scss */
.infobox-md h2 *,
.infobox-md h3 * {
  margin: 0;
  line-height: 18px;
}
/* line 138, target/sass/courage/infobox/_all.scss */
.infobox-md::before {
  width: 48px;
}
/* line 143, target/sass/courage/infobox/_all.scss */
.infobox-md > .icon {
  top: 20px;
  left: 11px;
}
/* line 148, target/sass/courage/infobox/_all.scss */
.infobox-md + .button-bar.button-bar-attached {
  width: auto;
  padding-left: 60px;
  float: none;
}
/* line 153, target/sass/courage/infobox/_all.scss */
.infobox-md + .button-bar.button-bar-attached.button-bar-l-height {
  line-height: 32px;
}
/* line 163, target/sass/courage/infobox/_all.scss */
.infobox-compact {
  min-height: 16px;
  padding: 9px 9px 9px 40px !important;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: #ddd;
  background-color: #fbfbfb;
}
/* line 172, target/sass/courage/infobox/_all.scss */
.infobox-compact a,
.infobox-compact p,
.infobox-compact li {
  line-height: 16px;
}
/* line 178, target/sass/courage/infobox/_all.scss */
.infobox-compact h2 + *,
.infobox-compact h3 + *,
.infobox-compact p + *,
.infobox-compact ul + *,
.infobox-compact ol + *,
.infobox-compact li + * {
  margin-top: 5px;
}
/* line 187, target/sass/courage/infobox/_all.scss */
.infobox-compact::before {
  width: 30px;
}
/* line 192, target/sass/courage/infobox/_all.scss */
.infobox-compact + p {
  margin-top: 9px;
}
/* line 196, target/sass/courage/infobox/_all.scss */
.infobox-compact > .icon {
  top: 9px;
  left: 6px;
}
/* line 205, target/sass/courage/infobox/_all.scss */
.infobox-xl {
  min-height: 18px;
  padding: 26px 36px 26px 108px !important;
}
/* line 209, target/sass/courage/infobox/_all.scss */
.infobox-xl::before {
  width: 84px;
}
/* line 213, target/sass/courage/infobox/_all.scss */
.infobox-xl > .icon {
  top: 22px;
  left: 18px;
}
/* line 218, target/sass/courage/infobox/_all.scss */
.infobox-xl p,
.infobox-xl ul {
  width: 75%;
  margin-top: 20px;
}
/* line 224, target/sass/courage/infobox/_all.scss */
.infobox-xl p,
.infobox-xl li {
  font-size: 14px;
  line-height: 20px;
}
/* line 230, target/sass/courage/infobox/_all.scss */
.infobox-xl h2,
.infobox-xl h3 {
  font-size: 18px;
}
/* line 234, target/sass/courage/infobox/_all.scss */
.infobox-xl h2 *,
.infobox-xl h3 * {
  margin: 0;
  line-height: 18px;
}
/* line 245, target/sass/courage/infobox/_all.scss */
.infobox-teach h2,
.infobox-teach h3 {
  color: #835ab1;
  font-weight: 200;
}
/* line 251, target/sass/courage/infobox/_all.scss */
.infobox-teach.infobox-dismiss .button-teach {
  margin-top: 20px;
  float: right;
}
/* line 259, target/sass/courage/infobox/_all.scss */
.infobox-dismiss {
  padding-right: 30px !important;
}
/* line 263, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-link {
  display: block;
  position: absolute;
  top: 10px;
  right: 8px;
  color: #5e5e5e;
  line-height: 14px;
  cursor: pointer;
}
/* line 273, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-link:hover {
  text-decoration: none;
}
/* line 277, target/sass/courage/infobox/_all.scss */
.help-wrap .infobox.infobox-dismiss .infobox-dismiss-link {
  top: 0;
  right: 0;
}
/* line 283, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-hide {
  display: none !important;
}
/* line 292, target/sass/courage/infobox/_all.scss */
.infobox-confirm {
  position: absolute !important;
  top: 20px;
  left: 50%;
  width: 240px;
  margin-left: -154px;
  box-shadow: 0 2px 0 rgba(160, 160, 160, 0.1);
  z-index: 10;
}
/* line 302, target/sass/courage/infobox/_all.scss */
.infobox-confirm-fixed {
  position: fixed !important;
  top: 106px;
}
/* line 306, target/sass/courage/infobox/_all.scss */
.infobox-confirm-fixed .infobox-dismiss-link {
  top: 14px;
  right: 14px;
}
/* line 318, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-success::before,
.help-wrap .infobox.infobox-success::before,
.infobox-success::before {
  background-color: #4cbf9c;
}
/* line 324, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-warning::before,
.help-wrap .infobox.infobox-warning::before,
.infobox-warning::before {
  background-color: #f1d10d;
}
/* line 330, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-error::before,
.help-wrap .infobox.infobox-error::before,
.infobox-error::before {
  background-color: #e34843;
}
/* line 336, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-tip::before,
.infobox.infobox-subtle.infobox-teach::before,
.help-wrap .infobox.infobox-tip::before,
.help-wrap .infobox.infobox-teach::before,
.infobox-tip::before,
.infobox-teach::before {
  background-color: #835ab1;
}
/* line 346, target/sass/courage/infobox/_all.scss */
.infobox-warning .icon.processing-16 {
  width: 16px;
  height: 16px;
  background: url("/assets/img/ui/indicators/ajax-loader-processing-16.995b6ac81af8ed76a8ade6aba2f6d4d1.gif") no-repeat 0 0 transparent;
}
/* line 352, target/sass/courage/infobox/_all.scss */
.infobox-warning .icon.processing-24 {
  width: 24px;
  height: 24px;
  background: url("/assets/img/ui/indicators/ajax-loader-processing-24.2564f2a8efed77df6c170335ff3001ef.gif") no-repeat 0 0 transparent;
}
/* line 358, target/sass/courage/infobox/_all.scss */
.infobox-error .icon.processing-16 {
  width: 16px;
  height: 16px;
  background: url("/assets/img/icons/16x16/error-01.fa55d715ffe62d95fb0eded26d323a55.png") no-repeat 0 0 transparent;
}
/* line 365, target/sass/courage/infobox/_all.scss */
.infobox + .button-bar,
.infobox + .button-bar-small {
  border-top: 0;
}
/* line 370, target/sass/courage/infobox/_all.scss */
.infobox-no-border + .button-bar,
.infobox-no-border + .button-bar-small {
  border-top: 1px solid #dadada;
}
/* line 376, target/sass/courage/infobox/_all.scss */
.infobox-no-border {
  border: none !important;
}
/* line 380, target/sass/courage/infobox/_all.scss */
.infobox-text {
  padding: 0;
}
/* line 384, target/sass/courage/infobox/_all.scss */
.infobox-header {
  font-weight: bold;
}
/* line 388, target/sass/courage/infobox/_all.scss */
.infobox-divider {
  border-bottom: 1px dotted #ddd;
}
/* line 396, target/sass/courage/infobox/_all.scss */
.edit-form .infobox,
.read-only-form .infobox,
.ajax-form-editor .infobox,
.form-content-wrap .infobox,
.o-form .infobox,
.m-form .infobox,
.v-form .infobox,
.modal-content-wrap .infobox {
  background-color: #fff;
}
/* line 407, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle,
.help-wrap .infobox {
  padding: 0 0 0 18px !important;
  border: 0;
  background: transparent;
}
/* line 413, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle::before,
.help-wrap .infobox::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
  border-radius: 0;
  background-color: #007dc1;
  content: "";
}
/* line 424, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle .icon,
.help-wrap .infobox .icon {
  display: none;
}
/* line 4, target/sass/modules/infobox/_overrides.scss */
.infobox-teach + .ui-tabs {
  margin-top: 18px;
}
.reg-nav {
  color: #dbaa00 !important;
  border-top: solid 6px #dbaa00;
  padding-top: 10px;
}
.title-bar {
  margin-right: -15px;
  margin-left: -15px;
  margin-top: -5px;
}
input,
select {
  background: #fff;
  border: 2px solid #dde3e6;
  /* max-width: 400px !important; */
  display: block !important;
  border-radius: 0px !important;
  min-height: 30px;
  padding-left: 5px;
}
input[type="button"]:hover,
button:hover {
  background-color: var(--theme-primary) !important;
  border: 1px solid var(--theme-primary) !important;
  color: var(--regpwd-secondarytextcolor) !important;
  border-radius: 0px !important;
}
input[type="button"],
button {
  background-color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
  color: var(--regpwd-secondarytextcolor) !important;
  border-radius: 0px !important;
}
.create-acc {
  margin: auto;
  border: 1px solid #ccc;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 20px;
  height: 30px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  font-size: 14px;
  padding: 4px 15px;
  float: right;
}
.pwderror {
  display: block;
  background: #474c55;
  padding-left: 10px;
  color: #ffffff;
  border-bottom: 1px solid #eaeaea;
  max-width: 100%;
}
#userRegistration {
  max-width: 394px;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
}
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.splash {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: -1;
  object-fit: cover;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.regapps {
  max-width: 160px;
  width: 100px;
  padding: 5px;
  margin: 15px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}
.icon-wrap {
  border: 1px solid #acacac;
  width: 140px;
  border-radius: 3px;
  height: 60px;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f4f4f4));
  vertical-align: middle;
  display: table-cell;
}
.errorwrapper {
  /* position: absolute; */
  z-index: 999999999999999;
  width: 100%;
  /* padding-right: 30px; */
}
.validation-text {
  color: #bd0000;
  background: pink;
  border-radius: 3px;
  border: 1px solid #bd0000;
  padding: 5px 10px;
  margin: 10px 0px;
}
.margintop {
  margin-top: -20%;
  display: flex;
}
.okta-sign-in-header {
  padding: 10px 90px 10px 90px;
  position: relative;
  z-index: 10;
  transition: padding-bottom 0.4s;
}
.auth-org-logo {
  max-width: 120px !important;
  display: block;
  margin: 0 auto;
  max-height: 40px;
}
.phoneVerification {
  background: #f9f9f9;
  color: #fff;
  border: 1px solid #c3c3c3;
  font-size: 13px;
  display: inline-block !important;
  margin-top: 0px;
  line-height: 10px;
  margin-top: 2px;
  height: 30px;
  width: 100%;
  padding: 5px;
  white-space: normal;
  cursor: pointer;
}
.invalid {
  float: right;
  margin-right: 25px;
  margin-top: -20px;
  position: relative;
  z-index: 2;
  color: red;
}
.valid {
  float: right;
  margin-right: 25px;
  margin-top: -20px;
  position: relative;
  z-index: 2;
  color: green;
}
.red-border {
  border: 1px solid red !important;
}
.green-border {
  border: 1px solid green !important;
}
input[type="password"]:focus {
  outline: #dde3e6;
}
.row-spacing {
  padding: 0px 15px;
}
.field-spacing {
  padding: 5px 0px;
}
.phone-error {
  padding: 5px 15px;
  background: rgb(255, 192, 203);
  margin-top: 5px;
  width: 100%;
}
.brand-terms {
  margin: 6px;
  padding-left: 17px;
  font-size: 12px;
}
.input-terms {
  margin-right: 10px;
  float: left;
}
.send-code {
  padding: 5px 15px;
  color: #fff;
  border: 1px solid #c3c3c3;
  font-size: 12px;
  margin-top: -2px;
  min-height: 30px;
}
.input-reinvite {
  width: 100%;
  height: 45px;
  padding-left: 10px;
}
.field-reinvite {
  margin: auto;
  text-align: left;
  margin-bottom: 10px;
}
.verify-input {
  visibility: inherit;
  position: inherit;
  display: inline-block !important;
  padding-top: 0px;
  width: 100%;
}
.verify-sms {
  visibility: inherit;
  position: inherit;
  background: rgb(249, 249, 249);
  color: var(--regpwd-secondarytextcolor);
  border: 1px solid rgb(195, 195, 195);
  display: inline-block !important;
  font-size: 13px;
  border-radius: 3px;
  width: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// UserRegistration.vue?6f3f80c4